import { Card, Stack, Table, Badge, Tabs, Center, Loader } from "@mantine/core";
import { useResource } from "../../../shared/api";
import { PageHeader, MoneyDisplay, EmptyState } from "../../../shared/ui";

const TIER_COLOR: Record<string, string> = {
  BRONZE: "orange",
  SILVER: "gray",
  GOLD: "yellow",
  PLATINUM: "violet",
};

export function LoyaltyPage() {
  const { data: accountsData, isLoading } = useResource<any>("loyalty-accounts");
  const { data: txsData } = useResource<any>("loyalty-transactions");

  const accounts: any[] = accountsData?.results || accountsData || [];
  const txs: any[] = txsData?.results || txsData || [];

  if (isLoading) return <Center h={300}><Loader /></Center>;

  return (
    <Stack gap="md">
      <PageHeader title="Sadakat Programı" subtitle="Puanlar, tier'lar, leaderboard" />
      <Tabs defaultValue="accounts">
        <Tabs.List>
          <Tabs.Tab value="accounts">Hesaplar ({accounts.length})</Tabs.Tab>
          <Tabs.Tab value="transactions">İşlemler ({txs.length})</Tabs.Tab>
        </Tabs.List>

        <Tabs.Panel value="accounts" pt="md">
          {accounts.length === 0 ? <EmptyState title="Loyalty hesabı yok" /> : (
            <Card padding="sm" radius="md" withBorder>
              <Table.ScrollContainer minWidth={560}>
              <Table highlightOnHover>
                <Table.Thead>
                  <Table.Tr>
                    <Table.Th>Müşteri</Table.Th>
                    <Table.Th>Telefon</Table.Th>
                    <Table.Th>Tier</Table.Th>
                    <Table.Th ta="right">Bakiye</Table.Th>
                    <Table.Th ta="right">Toplam Kazanılan</Table.Th>
                  </Table.Tr>
                </Table.Thead>
                <Table.Tbody>
                  {accounts.map((a: any) => (
                    <Table.Tr key={a.id}>
                      <Table.Td>{a.customer_name || "-"}</Table.Td>
                      <Table.Td>{a.customer_phone}</Table.Td>
                      <Table.Td><Badge color={TIER_COLOR[a.tier] || "gray"}>{a.tier}</Badge></Table.Td>
                      <Table.Td ta="right"><MoneyDisplay minor={a.balance_minor} fw={700} /></Table.Td>
                      <Table.Td ta="right"><MoneyDisplay minor={a.lifetime_earned_minor} /></Table.Td>
                    </Table.Tr>
                  ))}
                </Table.Tbody>
              </Table>
              </Table.ScrollContainer>
            </Card>
          )}
        </Tabs.Panel>

        <Tabs.Panel value="transactions" pt="md">
          {txs.length === 0 ? <EmptyState title="Hareket yok" /> : (
            <Card padding="sm" radius="md" withBorder>
              <Table.ScrollContainer minWidth={520}>
              <Table highlightOnHover>
                <Table.Thead>
                  <Table.Tr>
                    <Table.Th>Tarih</Table.Th>
                    <Table.Th>Tip</Table.Th>
                    <Table.Th ta="right">Tutar</Table.Th>
                    <Table.Th>Referans</Table.Th>
                  </Table.Tr>
                </Table.Thead>
                <Table.Tbody>
                  {txs.slice(0, 100).map((t: any) => (
                    <Table.Tr key={t.id}>
                      <Table.Td>{new Date(t.created_at).toLocaleString("tr-TR")}</Table.Td>
                      <Table.Td><Badge variant="light">{t.transaction_type}</Badge></Table.Td>
                      <Table.Td ta="right" c={t.delta_minor >= 0 ? "green" : "red"}>
                        <MoneyDisplay minor={t.delta_minor} />
                      </Table.Td>
                      <Table.Td>{t.reference_type || "-"}</Table.Td>
                    </Table.Tr>
                  ))}
                </Table.Tbody>
              </Table>
              </Table.ScrollContainer>
            </Card>
          )}
        </Tabs.Panel>
      </Tabs>
    </Stack>
  );
}
